import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "leftButton", "rightButton", "tab"]

  connect() {
    this.updateButtons()
    this.containerTarget.addEventListener("scroll", this.updateButtons.bind(this))
    window.addEventListener("resize", this.updateButtons.bind(this))
  }

  scrollLeft() {
    this.containerTarget.scrollBy({ left: -150, behavior: "smooth" })
  }

  scrollRight() {
    this.containerTarget.scrollBy({ left: 150, behavior: "smooth" })
  }

  updateButtons() {
    const maxScroll =
      this.containerTarget.scrollWidth - this.containerTarget.clientWidth

    this.leftButtonTarget.style.display =
      this.containerTarget.scrollLeft > 0 ? "flex" : "none"

    this.rightButtonTarget.style.display =
      this.containerTarget.scrollLeft < maxScroll ? "flex" : "none"
  }

  centerActive(event) {
    event.target.scrollIntoView({
      behavior: "smooth",
      inline: "center",
      block: "nearest"
    })
  }
}